import React from "react";
import TicketsCustom from "../TicketsCustom";

const TicketResponsiveContainer = () => {
  return <TicketsCustom />;
};

export default TicketResponsiveContainer;
